//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;
export const GoToCompletedErrorStack = styled.article`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: -16px;
    & img {
        width: 25px;
    }
    span {
        font-size: 14px;
        color: var(--red-3);
    }
    strong {
        text-decoration: underline;
        text-decoration-thickness: 2px;
        cursor: pointer;
    }
`;